import 'mdn-polyfills/NodeList.prototype.forEach';
import Locator from './Locator';

document.addEventListener('DOMContentLoaded', () => {
  const locators = document.querySelectorAll('[data-locator]');
    if (!locators.length) {
      return;
    }
    locators.forEach((element) => {
      const locator = new Locator(element);
      locator.mount();
    });
});
